export default "__VITE_ASSET__DGYzrRUQ__";